import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, FileText } from 'lucide-react';
import { SiteFooter } from '@/components/common/SiteFooter';

interface PlaceholderPageProps {
  title: string;
  description?: string;
}

/**
 * Generic placeholder for footer-linked pages (Features, Security, Privacy,
 * Terms) until real content exists. Dark Navy & Sky theme, page-scoped.
 */
export const PlaceholderPage: React.FC<PlaceholderPageProps> = ({
  title,
  description = 'This page is being prepared. Content will be published here soon.',
}) => {
  const navigate = useNavigate();

  return (
    <div className="dark min-h-screen flex flex-col bg-background text-foreground">
      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="max-w-md w-full text-center">
          <div className="mx-auto w-16 h-16 rounded-full border border-border flex items-center justify-center mb-6">
            <FileText className="w-7 h-7 text-primary" />
          </div>
          <h1 className="text-3xl font-semibold tracking-tight mb-3">{title}</h1>
          <p className="text-muted-foreground leading-relaxed mb-8">{description}</p>
          <Button variant="outline" onClick={() => navigate(-1)} className="gap-2">
            <ArrowLeft className="w-4 h-4" />
            Go Back
          </Button>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
};

export default PlaceholderPage;
